import moment from 'moment'
import { Entity } from '../../../@types/SubmitProposal'
import { usePaymentStore } from '../../../Stores/paymentStore'
import { usePolicyholderDetailsStore } from '../../../Stores/policyholderDetailsStore'
import { useSimulatorStore } from '../../../Stores/simulatorStore'
import { useGetAdditionalEntityDetailsStore } from '../../../Stores/useGetAdditionalEntityDetailsStore'
import { useRunPetisSimulationStore } from '../../../Stores/useRunPetisSimulationStore'
import { useNationality } from '../../useNationality'

export const usePolicyholderPayload = () => {
  const { policyholderDetailsSelected } = usePolicyholderDetailsStore()
  const { policyholderAdditionalDetails } = useGetAdditionalEntityDetailsStore()
  const { initialDate, endDate } = useSimulatorStore()
  const { selectedIBAN } = usePaymentStore()
  const { runPetisSimulation } = useRunPetisSimulationStore()
  const { getNationality } = useNationality()

  const collectionMethod =
    runPetisSimulation?.runPetisSimulationResponse?.productData
      ?.collectionMethod

  const policyholderPayload: Entity = {
    academicQualifications: '', //TODO: Where to get this data?
    actualAge: 0, //TODO: Where to get this data? We calculate?
    addressDetails: {}, //TODO: Where to get this data?
    addresses: policyholderDetailsSelected?.addresses || [],
    addressId: '', //TODO: Where to get this data?
    ageasEmployee: '', //TODO: Where to get this data?
    annualBilling: 0, //TODO: Where to get this data?
    bankAccounts: [
      {
        //TODO: new ones
        atmEntity: '', //TODO: Where to get this data?
        atmReference: '', //TODO: Where to get this data?
        mandateId: '', //TODO: Where to get this data?

        accountOwnerName: '', //TODO: Where to get this data?
        bicSwift: '', //TODO: Where to get this data?
        collectionIban: selectedIBAN || '',
        collectionIbanBank: '', //TODO: Where to get this data?
        collectionIbanId: '', //TODO: Where to get this data?
        country: '', //TODO: Where to get this data?
        endDate,
        entityCreditor: '', //TODO: Where to get this data?
        reimbursementIban: '', //TODO: Where to get this data?
        reimbursementIbanId: '', //TODO: Where to get this data?
        startDate: moment().format(), //TODO: Where to get this data?
      },
    ], //TODO: Where to get this data?
    birthDate: policyholderDetailsSelected?.birthdate,
    blocks: [], //TODO: Where to get this data?
    caEs: [], //TODO: Where to get this data?
    clientId: '', //TODO: Where to get this data?
    clientNumber: '', //TODO: Where to get this data?
    collectionMethod: [
      {
        following: collectionMethod?.following || '',
        followingCode: collectionMethod?.followingCode || '',
        followingIndex: collectionMethod?.followingIndex || '',
        initial: collectionMethod?.initial || '',
        initialCode: collectionMethod?.initialCode || '',
        initialExternalId: collectionMethod?.initialExternalId || '',
        initialIndex: collectionMethod?.initialIndex || '',
      },
    ],
    companyFiscalNumber: 0, //TODO: Where to get this data?
    companyId: '', //TODO: Where to get this data?
    companyName: '', //TODO: Where to get this data?
    companyType: '', //TODO: Where to get this data?
    contacts: [], //TODO: Review this structure
    deathDate: moment().format(), //TODO: Where to get this data?
    drivingLicenses: [], //TODO: Where to get this data?
    endDate,
    eni: false, //TODO: Where to get this data?
    entityId: policyholderDetailsSelected?.idEntity || '',
    entityRole: '', //TODO: Where to get this data?
    entityType: policyholderDetailsSelected?.entityType || '',
    establishmentCountry: '', //TODO: Where to get this data?
    establishmentDate: moment().format(), //TODO: Where to get this data?
    externalId: '', //TODO: Where to get this data?
    externalReferences: [], //TODO: Where to get this data?
    fiscalNumber: Number(policyholderDetailsSelected?.vatNumber),
    gender: policyholderAdditionalDetails?.gender || '',
    genderCode: '', //TODO: Where to get this data?
    hasClaims: false, //TODO: Where to get this data?
    honoraryTitles: '',
    initialAccountInt: '',
    initialDate: moment(initialDate, 'DD-MM-YYYY').format('YYYY-MM-DD') || '',
    initialExternalAgentId: '', //TODO: Where to get this data?
    insuranceProfessional: '', //TODO: Where to get this data?
    intAccountRenewal: 0, //TODO: Where to get this data?
    jobs: policyholderAdditionalDetails?.professionList?.map((item) => ({
      employer: '', //TODO: Where to get this data?
      jobEndDate: moment().format(), //TODO: Where to get this data?
      jobID: item?.professionCode || '',
      jobName: item?.professionDescription || '',
      jobStartDate: moment().format(), //TODO: Where to get this data?
      occupationalStatus: '', //TODO: Where to get this data?
      professionalLicense: '', //TODO: Where to get this data?
    })),
    legalForm: '', //TODO: Where to get this data?
    mailingAddressId: '', //TODO: Where to get this data?
    maritalStatus: '', //TODO: Where to get this data?
    maritalStatusCode: '', //TODO: Where to get this data?
    name: policyholderDetailsSelected?.name || '',
    nationality:
      getNationality(policyholderAdditionalDetails?.nationality || '')
        ?.description || '',
    nationalityId: policyholderAdditionalDetails?.nationality || '',
    networkCode: '', //TODO: Where to get this data?
    numberOfEmployees: 0, //TODO: Where to get this data?
    ong: false, //TODO: Where to get this data?
    otherDetails: {}, //TODO: Where to get this data?
    otherDocuments: [], //TODO: Where to get this data?
    paperless: [], //TODO: Where to get this data?
    payer: false, //TODO: Where to get this data?
    paymentPercent: 0, //TODO: Where to get this data?
    phoneContactId: '', //TODO: Where to get this data?
    publicEntity: false, //TODO: Where to get this data?
    relations: [], //TODO: Where to get this data?
    renewalAndExtension: {}, //TODO: Where to get this data?
    renewalExternalAgentId: '', //TODO: Where to get this data?
    salaryVolume: 0, //TODO: Where to get this data?
    socialCapital: 0, //TODO: Where to get this data?
    socialSecurityNumber: 0, //TODO: Where to get this data?
    specificInformationDetails: {}, //TODO: Where to get this data?
    treatmentPronouns: '', //TODO: Where to get this data?
    website: '', //TODO: Where to get this data?
  }

  return {
    policyholderPayload,
  }
}
